import React, { useState} from 'react'
import { Link, useNavigate, Navigate } from 'react-router-dom';
import { auth, logInWithEmailAndPassword, emailValidation } from './firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import "./Login.css";

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [user] = useAuthState(auth); //, loading, error
    //const navigate = useNavigate();
    if (user) {
        console.log('user mail:: '+user.email);
        return <Navigate to="/home" replace />;
    }
    const onChangeEmail=(event) => {
        setEmail(event.target.value);
        if (!emailValidation(event.target.value)) {
            document.getElementById('email_input').style.color = 'red';
            document.getElementById('email_input').style.border = '2px solid red';
        }else{
            document.getElementById('email_input').style.color = 'green'
            document.getElementById('email_input').style.border = '2px solid green'
        }
    }

    return (
        <div className='login'>
            
            <div className='login__container'>
                <img src='/Logo_BLANCO.8829c4f6.svg' className='login__logo' alt='Carbonbox logo'></img>    
                <h2 className='login__h3' style={{ fontSize:'40px',fontFamily:'Source Sans Pro',fontWeight:'600',color:'#0B149E',marginTop:'20px',marginBottom:'25px' }}>Inicia sesión</h2>
                <p  className='login__h3'>Correo electrónico</p>
                <input id='email_input'
                    type="text"
                    className='login__textBox'
                    value={email}
                    //onChange={(e) => setEmail(e.target.value)}
                    onChange={onChangeEmail}
                    placeholder='Correo electrónico'
                />
                <p className='login__h3'>Contraseña</p>
                <input
                    type="password"
                    className='login__textBox'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder='Contraseña'
                />
                <div className='login__h3'>
                    <Link style={{ color:'#7D97F4'}} to="/reset">¿Olvidaste constraseña?</Link>
                </div>
                <div>
                    {/*<button
                        className='login_btn login__google'
                        onClick={signInWithGoogle}
                        >
                        Iniciar sesión con Google
                    </button>*/}
                    <button
                        className='login__btn'
                        onClick={() => logInWithEmailAndPassword(email, password)}
                        >
                        INGRESAR
                    </button>
                </div>
                {/* {<div className='login__h3'>
                    <Link style={{ color:'#7D97F4'}} to="/register">Regístrate!</Link>
                </div>} */}
            </div>
            <div style={{width:'65%',height:'100%'}} className='login__container'>
                <h2 style={{color:'#0B149D', paddingTop:'150px',paddingLeft:'15%',paddingRight:'15%'}}>Revierte el <span style={{fontSize:'45px',color:'white',fontWeight:'bold',background:'#2FC268'}}>CAMBIO CLIMATICO</span> <span style={{fontSize:'45px',fontWeight:'bold'}}>al reducir</span> el carbono de la atmosfera</h2>
                <img src='/bkg-img-0.svg' alt='background'></img>
            </div>
        </div>
    )
}

export  default Login;
/***
 * 
 * style={{ fontSize:'40px',fontFamily:'Source Sans Pro',fontWeight:'600',color:'#0B149E',marginTop:'20px',marginBottom:'25px' }}
 */